<div class="list">
  <div style="display:flex">
    <div class="line-height-l" style="min-width: 120px;">
      <div class="line-height-l" style="min-width: 120px;">
        <a uiSref="symap.project.projectSettings"  class="button mb-10"><i class="fa fa-chevron-left mr-5"></i> Nastavení</a>
      </div>
    </div>
    <div class="actions">
      <a (click)="onCreate()" class="button"><i class="fa fa-plus-square"></i>Vytvořit nového znalce</a>
    </div>
  </div>

  <h1>Znalci</h1>

  <filter [list]="list" (onChanged)="pageableList.onFilterChanged($event)">
    <div class="column-100">
      <input class="fulltext" type="text" placeholder="Fultextové hledání..." [(ngModel)]="list.filter.filters.searchText.values[0].id"/>
    </div>
  </filter>

  <div [loading]="list.loading">
    <div class="table-top-container">
      <div class="invisible cm-select-placeholder"></div>
      <pagescounter *ngIf="list.itemCount && list.list !== null" [list]="list" (callbackRegister)="pageableList.pagescounterCallbackRegister($event)"></pagescounter>
      <div class="page-count-select" *ngIf="list.itemCount && list.list !== null">
        <span>Záznamů na stránce</span>
        <gmt-select required="true" [data]="pageableList.dataPaging" field="itemsPerPage" [optionItems]="pageableList.itemsPerPageItems" (changed)="pageableList.changePageItems()" class="min-width-unset"></gmt-select>
      </div>
    </div>

    <div class="bordered" *ngIf="list.itemCount">
      <div class="table">
        <div class="head-group sticky">
          <div class="row">
            <span class="cell">Celé jméno</span>
            <span class="cell">Znalecká kancelář</span>
          </div>
        </div>
        <div class="row-group">
          <a class="row" *ngFor="let expert of list.list" uiSref="symap.project.projectSettings.experts.detail" [uiParams]="{ id: expert.id }">
            <span class="cell">{{ expert | subjectName }}</span>
            <span class="cell">{{ expert.kancelar }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="empty-info bordered pb-20 pt-20 centered-text" *ngIf="!list.itemCount && list.list !== null && !list.loading">
      <span>Nebyla nalezena žádná data.</span>
    </div>
  </div>

  <itemscounter
    *ngIf="list.itemCount && list.list !== null" [list]="list"
    (callbackRegister)="pageableList.itemcounterCallbackRegister($event)"
    style="max-width: 100px;"
  ></itemscounter>

  <pagination
    *ngIf="list.itemCount && list.list !== null"
    [list]="list"
    (callbackRegister)="pageableList.paginationCallbackRegister($event)"
  ></pagination>

  <help [helpId]="helpIds.SETTINGS_ADMINISTRATORS" class="cm-help-page"></help>
</div>

